/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1FeedbackFeedbackidLangsId202,
  DeleteApiV1FeedbackFeedbackidLangsId401,
  DeleteApiV1FeedbackFeedbackidLangsId404,
  DeleteApiV1FeedbackFeedbackidLangsId500,
  DeleteApiV1FeedbackFeedbackidLangsIdMutationResponse,
  DeleteApiV1FeedbackFeedbackidLangsIdPathParams,
} from "../../types/feedbackIdiomasController/DeleteApiV1FeedbackFeedbackidLangsId.ts";

export const deleteApiV1FeedbackFeedbackidLangsIdPathParamsSchema = z.object({
  feedbackId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1FeedbackFeedbackidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1FeedbackFeedbackidLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1FeedbackFeedbackidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1FeedbackFeedbackidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1FeedbackFeedbackidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1FeedbackFeedbackidLangsId500>;

export const deleteApiV1FeedbackFeedbackidLangsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1FeedbackFeedbackidLangsId202Schema,
  ) as unknown as ToZod<DeleteApiV1FeedbackFeedbackidLangsIdMutationResponse>;
